// Copyright (c) 2020 Deere & Company

import actions from '../actions-list';

export const setReports = ( unit, reports ) => ( {
    type: actions.SET_REPORTS,
    unit,
    reports
} );
